export enum SoundNameEnum {
    CASES_ACTIVE_SOUND = 'activeCasesSound',
    CASE_BATTLE_ACTIVE_SOUND = 'activeCaseBattleSound',
    CASES_GROUP = 'cases_sound',
  }